
import { defineComponent, PropType } from 'vue'
import { iOptions } from '../KpiDocumentDesigner'
import Card from 'primevue/card'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import KpiDocumentDesignerOptionsCardDescriptor from './KpiDocumentDesignerOptionsCardDescriptor.json'

export default defineComponent({
    name: 'kpi-edit-options-card',
    components: { Card, Checkbox, Dropdown },
    props: { propOptions: { type: Object as PropType<iOptions>, required: true } },
    data() {
        return {
            KpiDocumentDesignerOptionsCardDescriptor,
            options: null as iOptions | null
        }
    },
    wacth: {
        propOptions() {
            this.loadOptions()
        }
    },
    created() {
        this.loadOptions()
    },
    methods: {
        loadOptions() {
            this.options = this.propOptions
            this.options.showtarget = this.options.showtarget === 'true'
            this.options.showtargetpercentage = this.options.showtargetpercentage === 'true'
            this.options.showthreshold = this.options.showthreshold === 'true'
            this.options.showvalue = this.options.showvalue === 'true'
        }
    }
})
